import { render, staticRenderFns } from "./IframeView.vue?vue&type=template&id=7dde4dca&scoped=true&"
import script from "./IframeView.vue?vue&type=script&lang=js&"
export * from "./IframeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dde4dca",
  null
  
)

export default component.exports